export default __webpack_public_path__ + "static/media/Kat 9781408345054.32b8125f.jpg";